import { Amount } from "@goodfill/domain-properties/src";
import { formatCurrencyAmount } from "@goodfill/format-number";
import React from "react";

export const AccruedInterestAmountComponent = (props: { value: Amount }) => (
  <>
    {formatCurrencyAmount({
      value: props.value.toFixed(2),
      numDecimals: 2,
    })}
  </>
);
